import { getItemFromStorage } from '@utils/storage'

function convertResponse(res) {
  const response = {}

  if (res.status || res.data) {
    const { status, data } = res

    switch (status) {
      case 200:
        response.resData = data
        response.result = 'success'
        response.message = '성공적으로 처리되었습니다!'
        break
      case 201:
        response.resData = data
        response.result = 'success'
        response.message = '성공적으로 생성되었습니다!'
        break
      case 204:
        response.resData = []
        response.result = 'success'
        response.message = '성공적으로 삭제되었습니다!'
        break
      case 400:
        response.resData = null
        response.result = 'error'
        response.message = '잘못된 요청입니다!'
        break
      case 401:
      case 403:
        response.resData = null
        response.result = 'error'
        response.message = '접근 권한이 없거나 사용자 정보가 올바르지 않습니다!'
        break
      case 404:
        response.resData = null
        response.result = 'error'
        response.message = '존재하지 않는 요청입니다!'
        break
      default:
        response.resData = null
        response.result = 'error'
        response.message = '서버 오류입니다!'
    }
  } else {
    response.resData = null
    response.result = 'error'
    response.message = '서버 오류입니다!'
  }

  return response
}

function setInterceptors(withAuth, instance) {
  if (withAuth) {
    instance.interceptors.request.use(
      config => {
        const token = getItemFromStorage('token')

        config.headers = {
          authorization: token ? `Bearer ${token}` : null,
        }
        return config
      },
      error => Promise.reject(error.response),
    )
  }
  instance.interceptors.response.use(
    config => convertResponse(config),
    error => {
      Promise.reject(error.response)
      return convertResponse(error.response)
    },
  )
  return instance
}

export { setInterceptors }
